import { render } from "./ButtonBackToTop.vue?vue&type=template&id=34f54554"
import script from "./ButtonBackToTop.vue?vue&type=script&lang=js"
export * from "./ButtonBackToTop.vue?vue&type=script&lang=js"

import "./ButtonBackToTop.vue?vue&type=style&index=0&id=34f54554&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__